<template>
  <SettingsTableRow name="クレジットカード情報">
    <p>決済サービスのStripeのページ上でお手続きいただきます。</p>
    <a
      @click="openStripeEditCreditPage"
      :class="[
        $style.textLink,
        {
          [$style['textLink--disabled']]: !props.isEditablePeriod,
        },
      ]"
      >更新する</a
    >
  </SettingsTableRow>
</template>

<script setup lang="ts">
import { useGenerateStripeCreditCardSavingUrl } from '@/features/contract/useContract/useContract'
import { useAlert } from '@/libs/alertPortal'
import { captureException as newrelicCaptureException } from '@/newrelic'
import { useRouter } from 'vue-router'
import SettingsTableRow from '../SettingsTable/SettingsTableRow.vue'

const router = useRouter()

const props = defineProps<{
  isEditablePeriod: boolean
}>()

const { generateStripeCreditCardSavingUrl } =
  useGenerateStripeCreditCardSavingUrl(
    `${window.origin}${
      router.resolve({
        name: 'stripeCallback',
        query: { success: true.toString() },
      }).href
    }`,
    `${window.origin}${
      router.resolve({
        name: 'stripeCallback',
        query: { success: false.toString() },
      }).href
    }`
  )

const alert = useAlert()

const openStripeEditCreditPage = async () => {
  if (!props.isEditablePeriod) {
    return
  }

  try {
    const stripeUrl = await generateStripeCreditCardSavingUrl()
    window.open(stripeUrl, '_blank')
  } catch (error) {
    alert.error('エラーが発生しました。再度お試しください。')

    newrelicCaptureException(error)
  }
}
</script>

<style module lang="scss">
.textLink {
  cursor: pointer;

  &--disabled {
    text-decoration: line-through;

    &:hover {
      text-decoration: line-through;
    }
  }
}
</style>
